import DayViewItem from '../schema/DayViewItem';

/**
 * Interface for Grid Position for DayViewItem
 */
interface GridPosition {
    /**
     * Top pixel distance from the Grid top border
     */
    top: string;

    /**
     * Left pixel distance from the Grid left border
     */
    left: string;

    /**
     * Width of the DayViewItem as rendered in grid
     */
    width: string;

    /**
     * Height of the DayViewItem as rendered in grid
     */
    height: string;
}

/**
 * Generates grid position from day view item
 * @param item Day View Item
 * @param pixelPerMin Pixel used to render a minute
 */
export default function getGridPositionFromDayViewItem<T>(
    item: DayViewItem<T>,
    pixelPerMin: number
): GridPosition {
    const { layout, column } = item;
    const { top: layoutTop, left: layoutLeft, right: layoutRight, height: layoutHeight } = layout;

    const width = ((layoutRight - layoutLeft + 1) / column) * 100 + '%';
    const left = (layoutLeft / column) * 100 + '%';

    const position: GridPosition = {
        top: layoutTop * pixelPerMin + 'px',
        height: layoutHeight * pixelPerMin + 'px',
        width: width,
        left: left,
    };

    return position;
}
